module.exports = {"id":"dp5_4l3q1","text":"Assessing Digital Competence Needs","instructions":"Staying informed about digital technology changes helps identify personal learning needs.","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"5.4","questionType":"PickOne","random":false,"options":[{"id":"dp5_4l3q1-a1","text":"True","score":3},{"id":"dp5_4l3q1-a2","text":"Uncertain","score":0.4},{"id":"dp5_4l3q1-a3","text":"False","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat5.4/l3q1.json
// module id = 1344
// module chunks = 41